document.addEventListener("DOMContentLoaded", function () {

  const toggleBtn = document.querySelector(".cfs-toggle-btn");
  const content = document.querySelector(".cfs-content");

  if (!toggleBtn || !content) return;

  const tabs = document.querySelectorAll(".cfs-tab");
  const contents = document.querySelectorAll(".cfs-tab-content");
  const tabsContainer = document.querySelector(".cfs-tabs");

  const getActiveContent = () =>
    document.querySelector(".cfs-tab-content.active");

  // INIT
  content.classList.add("open");
  toggleBtn.setAttribute("data-state", "open");

  const textSpan = document.createElement("span");
  textSpan.classList.add("cfs-toggle-text");

  const arrow = toggleBtn.querySelector(".cfs-toggle-btn-arrow");

  toggleBtn.innerHTML = "";
  textSpan.textContent = "Hide detailed specifications";
  toggleBtn.appendChild(textSpan);
  toggleBtn.appendChild(arrow);

  // Initial height
  content.style.maxHeight = content.scrollHeight + "px";

  // TOGGLE
  toggleBtn.addEventListener("click", () => {
    const isOpen = content.classList.contains("open");

    if (isOpen) {
      content.style.maxHeight = content.offsetHeight + "px";
      content.offsetHeight;

      content.style.maxHeight = "0px";

      content.classList.remove("open");
      toggleBtn.setAttribute("data-state", "closed");
      textSpan.textContent = "Show detailed specifications";

    } else {
      content.classList.add("open");

      const height = content.scrollHeight;

      content.style.maxHeight = "0px";
      content.offsetHeight;

      content.style.maxHeight = height + "px";

      toggleBtn.setAttribute("data-state", "open");
      textSpan.textContent = "Hide detailed specifications";
    }
  });

  //  TABS
  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      const target = tab.dataset.tab;

      const currentActive = getActiveContent();
      const nextActive = document.getElementById(target);

      if (!nextActive || currentActive === nextActive) return;

      // Lock current height BEFORE switching
      const startHeight = content.offsetHeight;
      content.style.maxHeight = startHeight + "px";

      // Switch tabs
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      tab.classList.add("active");
      nextActive.classList.add("active");

      // Animate height to new content
      requestAnimationFrame(() => {
        const endHeight = content.scrollHeight;
        content.style.maxHeight = endHeight + "px";
      });

      if (window.innerWidth <= 768) {
        requestAnimationFrame(() => {
          tab.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest"
          });
        });
      }
    });
  });

});